import TenantTrackerProfile from './TenantTrackerProfile.vue';

export default TenantTrackerProfile;
